/* istanbul ignore file */

export const FILTER_LIST_RESET = 'Reset all';
export const FILTER_LIST_TITLE = 'Filter';

export const FILTER_CONTROLS_CLOSE = 'Close';
